import React from 'react';
import { useTheme } from 'styled-components';
import Form from '../../../../../form';
import { TFormVariant } from '../../../../../form/Form.types';
import { InputPrefixSC, PrefixTextSC } from './input-suffix.styled';

interface InputPrefixProps {
  /**
   * Children, in our case data entry component
   */
  children?: React.ReactNode | string;
  /**
   * Variant of form
   */
  variant?: TFormVariant;
  style?: React.CSSProperties;
  className?: string;
}

const InputPrefix: React.FunctionComponent<InputPrefixProps> = ({
  children,
  variant,
  style,
  className,
}) => {
  const theme = useTheme();
  const settings = Form.useFormSettings({ variant });

  return (
    <InputPrefixSC style={style} className={className}>
      {typeof children === 'string' ? (
        <PrefixTextSC
          display={'body2'}
          variant="default"
          style={{
            color:
              settings.variant === 'on-dark'
                ? theme.color.tint.tertiaryDark
                : theme.color.tint.tertiary,
          }}
        >
          {children}
        </PrefixTextSC>
      ) : (
        children
      )}
    </InputPrefixSC>
  );
};

export default InputPrefix;
